import { getPreview, prefixApiUrl } from 'config';
import { createSelector } from 'reselect';
import moment from 'moment';

const getContent = (data: any, id: any) => {
  let contentDOM = '';

  if (data) {
    data.forEach((card: any, index: number) => {
      let type: any = Object.keys(card)[0];
      let value: any = Object.values(card)[0];
      let contentCard = '<div>';

      if (type == 'ops') {
        contentCard = contentCard + `<div class="article-main">${value}</div>`;
      } else if (type == 'quote') {
        contentCard =
          contentCard +
          `<blockquote class="blockquote article-main__blockquote">${value}</blockquote>`;
      } else if (type == 'quoteAuthor') {
        let valueUrl = 'https://via.placeholder.com/200x200';
        if (value.url && value.url.length) {
          valueUrl = value.url;
        }
        contentCard =
          contentCard +
          `<div class="quote-author">

                                      <div class="quote-author__common">

                                        <div class="quote-author__image">
                                          <div
                                            class="other-article article-main__other-article -card-image-preview-link"
                                          >
                                            <img
                                                src="${valueUrl}"
                                                alt="img"
                                                class="other-article__img"
                                            />
                                          </div>
                                        </div>

                                        <div class="quote-author__name">${value.fio}</div>
                                        <div class="quote-author__place">${value.place}</div>

                                      </div>

                                      <div class="quote-author__text">${value.text}</div>
                                    </div>`;
      } else if (type == 'qa') {
        contentCard =
          contentCard +
          `<div class="qa">
                    <div class="qa__title">${value.title}</div>
                    <div class="qa__text">${value.text}</div>
                </div>`;
      } else if (type == 'article') {
        let article = value;
        let articleTitle = article.title,
          articleMetas = article.meta,
          articlePreview =
            (articleMetas &&
              articleMetas.length > 0 &&
              articleMetas.filter((item: any) => {
                return item.slug == 'preview';
              })) ||
            '',
          articleCategory =
            (article.get_categories &&
              article.get_categories.length > 0 &&
              article.get_categories[0].title) ||
            '';
        contentCard =
          contentCard +
          `<a href="${article.slug}"
                                            class="other-article article-main__other-article"
                                        >
                                            <span class="tag other-article__tag">
                                                ${articleCategory}
                                            </span>
                                            <img
                                                src="${
                                                  (articlePreview[0] &&
                                                    articlePreview[0].value) ||
                                                  'https://via.placeholder.com/1000x375'
                                                }"
                                                alt="img"
                                                class="other-article__img"
                                            />
                                            <span class="other-article__title">${articleTitle}</span>
                                        </a>`;
      } else if (type == 'image') {
        let imageUrl = value.url;
        if (!imageUrl || (imageUrl && !imageUrl.length)) {
          imageUrl = 'https://via.placeholder.com/1000x375';
        }
        contentCard =
          contentCard +
          `<div
                                            class="other-article article-main__other-article"
                                        >
                                            <img
                                                src="${imageUrl}"
                                                alt="img"
                                                class="other-article__img"
                                            />
                                            <span class="other-article__title">${value.description}</span>
                                        </div>`;
      } else if (type == 'video') {
        let video = value.url,
          title = value.title,
          videoId = video.split('?v='),
          videoUrl = 'https://www.youtube.com/embed/' + videoId[1];
        if (video.indexOf('?v=') == -1) {
          videoUrl = video;
        }
        contentCard =
          contentCard +
          `<div class="post-video others__post-video article-main__video" style="height: 375px;">
                                            <div class="post-video__link">
                                                <iframe id="video-${id}-${index}" class="post-video__video"  width="100%" height="100%" src="${videoUrl}?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                <h3 class="post-video__title">
                                                    ${title}
                                                </h3>
                                                <div class="tag tag--red post-video__tag">
                                                    Видео
                                                </div>
                                                <div class="video-icon">
                                                    <div class="video-icon__triangle"></div>
                                                </div>
                                            </div>
                                        </div>`;
      } else if (type == 'embed') {
        const addSpaceAfterLink = (match: any) => {
          let newString = match.replace('</a>', '');
          return '</a> ' + newString;
        };
        value = value.replace(/<\/a>[а-яА-Я]/g, addSpaceAfterLink);
        value = value.replace('[TEXT]', '');
        value = value.replace('[HTML]', '');
        value = value.replace('[script', '<script');
        value = value.replace('"]', '">');
        value = value.replace('[/script]', '</script>');
        value = value.replace(/&lt;/g, '<');
        value = value.replace(/&gt;/g, '>');
        contentCard = contentCard + value;
      }

      contentCard = contentCard + '</div>';

      contentDOM = contentDOM + contentCard;
    });
  }

  return contentDOM;
};

const articleList = (state: any) => state.article.itemsArticleList;

export const articleListSelector = createSelector([articleList], items => {
  let data: {} = {};

  if (items) {
    let like, dislike;

    if (items.likes) {
      like = items.likes.likes;
      dislike = items.likes.dislikes;
    }

    let dateArticle = items.created_at;
    if (items.publication_at) {
      dateArticle = items.publication_at;
    }

    let category = null;

    if (items.get_categories && items.get_categories.length > 0) {
      category = items.get_categories[0].slug;
    }

    data = {
      key: items.id,
      id: items.id,
      link: '/' + items.categories_path + '/' + items.slug,
      slug: items.slug,
      title: items.title,
      seo_title: items.seo_title,
      seo_description: items.seo_description,
      content:
        (typeof items.content == 'string' &&
          items.content &&
          items.content.length > 1 &&
          getContent(JSON.parse(items.content), items.id)) ||
        getContent(items.content, items.id),
      date: moment(dateArticle).locale('ru').format('DD MMMM YYYY в HH:mm'),
      dislike: dislike,
      type: 'news',
      img: 'article-header-img',
      announce_img: getPreview(
        items.get_post_types,
        items.announce_img,
        category,
        null,
        moment(dateArticle)
      ),
      announce_text: items.announce_text,
      like: like,
      category:
        (items.get_categories &&
          items.get_categories.length > 0 &&
          items.get_categories[0].title) ||
        null,
      categorySlug:
        (items.get_categories &&
          items.get_categories.length > 0 &&
          items.get_categories[0].slug) ||
        null,
      tags: items.get_tags,
      path: items.categories_path,
      author: {
        ...items.author,
        avatar:
          (items.author &&
            items.author.avatar &&
            ((items.author.avatar.indexOf('http') !== -1 &&
              items.author.avatar) ||
              prefixApiUrl + 'storage/' + items.author.avatar)) ||
          '/img/no-avatar-comment.png',
      },
      additional_authors: {
        ...items.additional_authors,
        avatar:
          (items.author &&
            items.author.avatar &&
            ((items.author.avatar.indexOf('http') !== -1 &&
              items.author.avatar) ||
              prefixApiUrl + 'storage/' + items.author.avatar)) ||
          '/img/no-avatar-comment.png',
      },
      user_id: (items.author_id && parseInt(items.author_id)) || items.user_id,
      banner:
        (items.ads_img &&
          `<img src="${prefixApiUrl}storage/${items.ads_img}" />`) ||
        items.ads_banner,
      next_post: items.next_post,
    };
  }
  return data;
});
